import { Component, OnInit } from '@angular/core';
import { FacebookService, InitParams } from 'ngx-facebook';

@Component({
  selector: 'app-chat-facebook',
  templateUrl: './chat-facebook.component.html',
  styleUrls: ['./chat-facebook.component.scss']
})
export class ChatFacebookComponent implements OnInit {

  constructor(
    private facebookService: FacebookService
  ) { }

  ngOnInit(): void {
    this.initFacebookService();
  }

  private initFacebookService(): void {
    const initParams: InitParams = { xfbml:true, version:'v10.0'};
    this.facebookService.init(initParams);
  }
}
